import { render, staticRenderFns } from "./BanderaLogoComponent.vue?vue&type=template&id=44bc121e&scoped=true&"
import script from "./BanderaLogoComponent.vue?vue&type=script&lang=js&"
export * from "./BanderaLogoComponent.vue?vue&type=script&lang=js&"
import style0 from "./BanderaLogoComponent.vue?vue&type=style&index=0&id=44bc121e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc121e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VImg,VRow})
